<script lang="ts">
import { PopupDialog } from "./popup-dialog";

export default PopupDialog;
</script>

<template>
    <Dialog
        v-model:visible="model.show"
        :modal="true"
        :dismissableMask="model.closeOnOutsideClick"
        :showHeader="false"
        :breakpoints="{ '400px': '90vw' }"
        contentStyle="overflow: overlay; padding: 0px; background-color: transparent;"
        style="width: 440px"
    >
        <div v-if="model.show && !model.isLoginPopupOpen" class="popup__wrapper">
            <div class="popup__close" v-if="model.showCloseButton">
                <button
                    class="dashboard__popup-closeBtn"
                    type="button"
                    @click="() => (model.show = false)"
                >
                    <svg class="sprite-icon" width="18" height="18">
                        <use xlink:href="/img/sprite.svg#close"></use>
                    </svg>
                </button>
            </div>
            <div class="popup__top">
                <img v-if="model.type === 'warning'" alt="" />
                <div class="popup__decline">
                    {{ model.message }}
                </div>
            </div>
            <div class="popup__bottom">
                <div class="popup__btn">
                    <button
                        v-for="(button, index) in model.buttons"
                        :key="index"
                        class="button"
                        :class="getButtonClass(button)"
                        type="button"
                        @click="doButtonAction(button)"
                    >
                        {{ button.title }}
                    </button>
                </div>
            </div>
        </div>
        <div v-if="model.show && model.isLoginPopupOpen" class="popup__wrapper c-p-w">
            <div class="popup__close" v-if="model.showCloseButton">
                <button
                    class="dashboard__popup-closeBtn"
                    type="button"
                    @click="
                        () => {
                            model.show = false;
                            model.isLoginPopupOpen = false;
                        }
                    "
                >
                    <svg class="sprite-icon" width="18" height="18">
                        <use xlink:href="/img/sprite.svg#close"></use>
                    </svg>
                </button>
            </div>
            <div class="popup__top c-p-t">
                <div class="popup__decline">
                    {{ i18n.t("authRequiredPopup.message") }}
                </div>
            </div>

            <div class="popup__bottom c-p-b">
                <form class="login__form" @submit="login.onSubmit" action="#">
                    <div class="row form__field">
                        <div
                            class="col form__col"
                            :class="{ 'form__group--active': login.username }"
                        >
                            <base-input
                                class="form__input"
                                type="text"
                                :class="{ '--error': login.usernameError }"
                                v-model="login.username"
                                id="username"
                                name="username"
                            />
                            <label class="form__label" :for="`username`">{{ i18n.t("auth.login") }}</label>
                        </div>
                    </div>
                    <div class="row form__field">
                        <div
                            class="col form__col"
                            :class="{ 'form__group--active': login.password }"
                        >
                            <base-input
                                class="form__input"
                                type="password"
                                v-model="login.password"
                                ref="passwordInput"
                                :class="{ '--error': login.passwordError }"
                                id="password"
                                name="password"
                            />
                            <label class="form__label" :for="`password`">{{ i18n.t("auth.password") }}</label>
                            <button class="form__pass" type="button">
                                <svg
                                    @click="togglePassword()"
                                    class="sprite-icon form__eye"
                                    width="18"
                                    height="18"
                                >
                                    <use xlink:href="/img/sprite.svg#eye-off"></use>
                                </svg>
                            </button>
                        </div>
                    </div>
                    <div class="form__link">
                        <router-link
                            v-if="signUpURL"
                            class="form__fpass p-mr-3"
                            :to="signUpURL"
                            @click="
                                () => {
                                    model.show = false;
                                    model.isLoginPopupOpen = false;
                                }
                            "
                        >
                            {{ i18n.t("authRequiredPopup.signUp") }}
                        </router-link>
                        <router-link
                            class="form__fpass"
                            to="/forgot-password"
                            @click="
                                () => {
                                    model.show = false;
                                    model.isLoginPopupOpen = false;
                                }
                            "
                        >
                            {{ i18n.t("auth.forgotPassword") }}?
                        </router-link>
                    </div>
                    <div class="form__btn">
                        <button class="button" type="submit">
                            {{ i18n.t("auth.signIn") }}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </Dialog>
</template>

<style scoped>
.popup__decline {
    margin-top: 0.333333rem;
    font-size: 27px;
    line-height: 33px;
}
.c-p-t {
    padding: 1.666667rem;
    border-bottom: none;
}
.c-p-b {
    padding: 13px 32px;
}
.c-p-w {
    height: 535px;
}
.c-m-m {
    padding: 20px 20px;
    line-height: 22px;
}
</style>
